import { EndpointQueryParameters } from '../../../types/strapi/strapi'

/**
 * Лёгкий detail-query для popover статуса подготовки.
 * Запрашивается только при открытии popover (кэш RTK Query по documentId).
 */
export const shipmentStatusQueryParams: EndpointQueryParameters = {
    fields: ['documentId', 'approved'],
    populate: {
        tasks: {
            fields: ['documentId', 'type', 'taskStatus', 'createdAt'],
            populate: {
                performer: {
                    fields: ['username'],
                },
            },
        },
        form_orders: {
            fields: ['documentId', 'id', 'orderStatus', 'estimatedDate'],
        },
        stamp: {
            populate: {
                last_order: {
                    fields: ['orderStatus', 'estimatedDate'],
                },
            },
        },
        blankPreviewFiles: {
            fields: ['documentId'],
        },
        materialRequirements: {
            populate: {
                material_type: {
                    fields: ['documentId', 'name'],
                    populate: {
                        unit: {
                            fields: ['shortName'],
                        },
                    },
                },
                configurations: {
                    populate: {
                        material: {
                            fields: ['documentId', 'width'],
                        },
                    },
                },
            },
        },
    },
}
